import { useIdleTimer } from 'react-idle-timer'

// n秒間操作がなかったらリロードする
const useRefreshByIdleTime = (timeoutSeconds: number) => {
  const handleOnIdle = () => window.location.reload()
  useIdleTimer({
    timeout: 1000 * timeoutSeconds,
    onIdle: handleOnIdle,
  })
}

export default useRefreshByIdleTime
